import merge from 'lodash.merge';
import { darkTheme, lightTheme, SYSTEM_FONT } from '@sketch/global-styles';
import { localStorageKeys } from '@sketch/constants';
import { getParsedItem } from '@sketch/utils';

// doing a hack to know which theme we want to apply
const chosenTheme = getParsedItem(localStorageKeys.theme);
const currentTheme = chosenTheme === 'dark' ? darkTheme : lightTheme;
/**
 * Important note: don't use any HSL color in these stripe style objects,
 * Stripe doesn't support it, an error is thrown and inputs are unusable.
 *
 * This is the documentation about style object where it's not clear that they
 * don't accept HSL: https://stripe.com/docs/js/appendix/style?type=card
 */
const commonStyles = () => {
    return {
        base: {
            fontFamily: `Marfa, ${SYSTEM_FONT}`,
            fontSize: currentTheme.fontSizes.E,
            fontSmoothing: 'antialiased',
            color: currentTheme.colors.stripe.foreground,
        },
        invalid: {
            color: currentTheme.colors.stripe.foreground,
        },
    };
};
const invalidStyles = () => {
    return merge({}, commonStyles(), {
        base: {
            '::placeholder': {
                color: currentTheme.colors.stripe.invalid,
            },
        },
    });
};

export { commonStyles, invalidStyles };
